import { Modal } from '@material-ui/core';
import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
    root: {
        width: '100%',
        minHeight: '100vh',
        display: 'relative',
        margin: 0,
        padding: 0,
        background: '-webkit-linear-gradient(-45deg, #183850 0, #183850 25%, #192C46 50%, #22254C 75%, #22254C 100%)',
      },
      wrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        alignItems: 'center',
        justifyContent: 'center',
        webkitTransform: 'translate(-50%, -50%)',
        mozTransform: 'translate(-50%, -50%)',
        msTransform: 'translate(-50%, -50%)',
        oTransform: 'translate(-50%, -50%)',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
      },
      title: {
        color: 'white',
        fontFamily: 'arial',
        fontWeight: 'bold',
        fontSize: 50,
        letterSpacing: 5,
        lineHeight: '1rem',
        textShadow: '0 0 3px white',
      },
      text: {
        color: '#f1f1f1',
        fontFamily: 'arial',
        fontWeight: 300,
        fontSize: 16,
      },
      button: {
        display: 'block',
        margin: '20px 0 0',
        padding: '15px 30px',
        background: '#22254C',
        color: 'white',
        fontFamily: 'arial',
        letterSpacing: 5,
        borderRadius: '.4rem',
        textDecoration: 'none',
        boxShadow: '0 0 15px #22254C',
        cursor: 'pointer'
      }
});

export default function (ComposedComponent) {
  class NetworkDetector extends Component {
    state = {
      isDisconnected: false
    }

    componentDidMount() {
      this.handleConnectionChange();
      window.addEventListener('online', this.handleConnectionChange);
      window.addEventListener('offline', this.handleConnectionChange);
    }

    componentWillUnmount() {
      window.removeEventListener('online', this.handleConnectionChange);
      window.removeEventListener('offline', this.handleConnectionChange);
    }


    handleConnectionChange = () => {
      const condition = navigator.onLine ? 'online' : 'offline';
      if (condition === 'online') {
        const webPing = setInterval(
          () => {
            fetch('//google.com', {
              mode: 'no-cors',
              })
            .then(() => {
                const {isDisconnected} = this.state
              this.setState({ isDisconnected: false }, () => {
                return clearInterval(webPing)
              });
              if(isDisconnected){
                  window.location.reload()
              }
            }).catch(() => this.setState({ isDisconnected: true }) )
          }, 2000);
        return;
      }

      return this.setState({ isDisconnected: true });
    }

    render() {
      const { isDisconnected } = this.state;
      const { classes } = this.props;
      return (
        <div>
            <Modal
                open={isDisconnected}
                onClose={() => {}}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className={classes.root}>
                    <div className={classes.wrapper}>
                        <h1 className={classes.title}>OFFLINE</h1>
                        <h4 className={classes.text}>Please check your internet connection</h4>

                        <p onClick={() => window.location.reload()} className={classes.button}>RETRY</p>
                    </div>
                </div>
            </Modal>
          <ComposedComponent {...this.props} />
        </div>
      );
    }
  }

  return withStyles(styles)(NetworkDetector);
}